import React, { lazy, useCallback } from "react";
import PropTypes from 'prop-types';
import FormControlTemplate from "../ui/formControlTemplate/FormControlTemplate";

const Checkbox = lazy(() => import("../ui/inputs/checkBox/CheckBox"));

const FormCheckboxField = ({
  name,
  keyId,
  value,
  onChange,
  labelName,
  dataField,
  formSetting,
  fieldSetting,
  overRideProps,
  onActionChange,
}) => {

  const handleCheckboxChange = useCallback((dataField, value) => {
    if (onChange) {
      onChange(dataField, value);
    }
  }, [onChange]);

  const handleButtonClick = (action) => {
    if (onActionChange) {
        onActionChange(action,dataField);
    }
};
  
  return (
    <div className="input-field-sec">
      {fieldSetting?.subTitle && (
        <div className="section-title">
          <h5>{fieldSetting.subTitle}</h5>
        </div>
      )}
      <div className="checkbox-label-part">
        <Checkbox
          keyId={keyId}
          name={name}
          label={labelName}
          checked={value === 'true' || value === true}
          isdisable={formSetting?.isViewOnly || (overRideProps?.isDisable !== undefined ? overRideProps?.isDisable : fieldSetting?.isDisable) || false}
          dataField={dataField}
          onChange={handleCheckboxChange}
          inputInfoConfig={fieldSetting?.inputInfoConfig}
          {...fieldSetting}
        />
        {fieldSetting?.isFormControl &&
          <FormControlTemplate
            fieldSetting={fieldSetting}
            handleButtonClick={handleButtonClick}
          />
        }
      </div>
    </div>
  );
};

FormCheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  keyId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  labelName: PropTypes.string,
  dataField: PropTypes.string.isRequired,
  onActionChange: PropTypes.func,
  formSetting: PropTypes.shape({
    isViewOnly: PropTypes.bool,
  }),
  overRideProps: PropTypes.shape({
    isDisable: PropTypes.bool,
  }),
  fieldSetting: PropTypes.shape({
    isDisable: PropTypes.bool,
    subTitle: PropTypes.string,
    isFormControl: PropTypes.bool,
    inputInfoConfig: PropTypes.object,
  }),
};

export default FormCheckboxField;
